<template>
    <div id="about">
        <div class="div-block-4"></div>
        <div data-collapse="medium" data-animation="default" data-duration="400" class="header-navigation fixed w-nav">
            <NetworkStatus/>
            <HeaderMenu/>
        </div>

        <div>
            <div class="section section-color center">
                <div class="w-container" style="padding:50px 0 0 0">
                    <h1 class="key-number">LocalScale for Education</h1>
                </div>
            </div>

            <div class="center" style="margin:20px 30px">
                <div class="industry-container">
                    <div class="industry-text">
                        <p style="font-size: 18px;font-weight:bold">Elevate your local private school, daycare, or Montessori center with LocalScale, your strategic partner in targeted advertising for education</p>
                        <p>In today's competitive educational landscape, building a strong local reputation is paramount.</p>
                        <p>With LocalScale, you can enhance your institution's visibility and attract prospective students and families in your community.</p>
                        <p>Whether you're promoting your school's unique curriculum, nurturing environment, or extracurricular offerings, our precision-targeted ad network enables you to reach families who value quality education for their children.</p>
                        <p>By leveraging LocalScale, you can ensure that your institution stands out from the competition and remains top-of-mind when parents are considering educational options for their children.</p>
                        <p>Let us help you grow enrollment and establish your institution as a trusted educational leader in your community.</p>
                        <div class="button-group" style="margin-top: 20px;margin-bottom: 10px;">
                            <div class="navigation-action"><a href="signup.html" class="ds-button button-small w-button">{{$t('get_started')}}</a></div>
                        </div>
                    </div>
                    <div class="industry-image">
                        <img src="images/industry-education.png" alt="Education">
                    </div>
                </div>
            </div>

            <div style="width: 100%;background-color:#e6faf6;">
                <div class="testimonial">
                    <div class="testimonial-stars">
                        <img src="images/star.svg" loading="lazy" alt="Star">
                        <img src="images/star.svg" loading="lazy" alt="Star">
                        <img src="images/star.svg" loading="lazy" alt="Star">
                        <img src="images/star.svg" loading="lazy" alt="Star">
                        <img src="images/star.svg" loading="lazy" alt="Star">
                    </div>
                    <h3 class="testimonial-quote">“LocalScale has been instrumental in helping our private school gain visibility and attract new families. Their targeted advertising solutions allowed us to reach parents who were actively seeking quality education for their children, resulting in a significant increase in enrollment. Thanks to LocalScale, we've been able to showcase our school's values and offerings to our community and continue providing an exceptional educational experience to our students.”</h3>
                    <p class="testimonial-customer">– Sarah Lee, Principal at Sunshine Academy</p>
                </div>
            </div>

            <Plans :what_are_you_waiting_for="true"/>
        </div>

        <Footer/>

    </div>
</template>

<script>
import HeaderMenu from "../components/HeaderMenu";
import NetworkStatus from "../components/NetworkStatus.vue";
import Footer from "../components/Footer";
import Plans from "../components/Plans";

export default {
    components: {
        HeaderMenu, NetworkStatus, Footer, Plans
    }
}
</script>

<style>
body {
    font-family: Inter, sans-serif;
    background-color: #fff;
}
p {
    color: black;
    margin: 10px;
    font-size: 16px;
}
h2 {
    text-align: center;
}
a {
    text-decoration: none;
    color: #1f1f1f
}
</style>
